import styled from '@emotion/styled';
import { css } from '@emotion/react';

export const TextFieldWrapper = styled('div')(({ theme: { spacing } }) => {
    return css`
        margin-bottom: ${spacing['16px']};
    `;
});

export const CallToActionRow = styled('div')(() => {
    return css`
        display: flex;
        justify-content: flex-end;
        width: 100%;
    `;
});

export const PropertyBlock = styled('div')(
    ({ theme: { spacing } }) => css`
        margin-bottom: ${spacing['16px']};
    `
);

export const ButtonWithIconText = styled('text')(
    () => css`
        font-weight: 400;
    `
);
